/* lua.js generated code 0.1 */

cc.ccp = ccp = cc.p
cc.ccc3 = ccc3 = cc.math.Vec3
cc.ccc4 = ccc4 = cc.math.Vec4
cc.CCSizeMake = CCSizeMake = cc.size
cc.CCSequence = CCSequence = cc.Sequence
cc.CCDelayTime = CCDelayTime = cc.DelayTime
cc.CCCallFunc = CCCallFunc = cc.CallFunc
cc.CCRectMake = CCRectMake = cc.rect
cc.CCPointMake = CCPointMake = cc.p

LuaArray = function() {
    this.list = sTable()
}

LuaArray.create = function() {
    return new LuaArray()
}

LuaArray.prototype.addObject = function(obj) {
    table.insert(this.list, obj)
}
// TODO: check
LuaArray.prototype.toLuaArray = function() {
    return this.list.slice(1)
}

cc.LuaArray = LuaArray
